import * as routes from './mainRoutes';
import IndustryController from '../../client/applications/main/controllers/IndustryController';
import BusinessIdeaController from '../../client/applications/main/controllers/BusinessIdeaController';
import TagPageController from '../../client/applications/main/controllers/TagPageController';

export const DESCRIPTOR_ONBOARDING_LIST = [
  {
    path: routes.INDUSTRY,
    key: 'industry',
    route: IndustryController,
    title: 'BNG_ON_BOARDING_INDUSTRY_HEADER',
    subTitle: 'BNG_ON_BOARDING_INDUSTRY_SUB_HEADER'
  },
  {
    path: routes.COMPANY_DETAILS,
    key: 'companyDetails',
    route: BusinessIdeaController,
    title: 'BNG_ON_BOARDING_NAME_HEADER'
    // subTitle: 'BNG_ON_BOARDING_NAME_SUB_HEADER'
  },

  {
    path: routes.TAGS,
    key: 'tagsSelector',
    route: TagPageController,
    title: 'BNG_ON_BOARDING_TAGS_HEADER',
    subTitle: 'BNG_ON_BOARDING_TAGS_SUB_HEADER'
  }
];
